import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizePermissionSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-permission-scheme',
	path: '/jira/settings/system/performance/permission-scheme/:permissionSchemeId/optimize',
};
